export default {
  "Choose a time": "اختر وقتًا",
  "Choose a time ·": "اختر وقتًا ·",
  "Choose a treatment and a moment that suits you. We will take care of the rest.": "اختر العلاج والوقت الذي يناسبك، وسنتكفل بالباقي.",
  "Choose an Excel (.xlsx / .xls) or CSV file up to 5 MB.": "اختر ملف Excel (‎.xlsx / .xls) أو CSV بحجم أقصى 5 ميغابايت.",
  "Choose an available time": "اختر وقتًا متاحًا",
  "Choose column": "اختر العمود",
  "Choose how customers can pay when they order from your website.": "اختر طرق الدفع المتاحة للعملاء عند الطلب من موقعك.",
  "Choose one option, or skip to order without options": "اختر خيارًا واحدًا، أو تخطَّ للطلب بدون خيارات",
  "Choose the layout customers see when booking with you": "اختر التصميم الذي يراه العملاء عند الحجز لديك",
  "Choose the layout for your product catalog": "اختر تصميم كتالوج منتجاتك",
  "Choose the overall layout - the editor below customizes text, images and colors on top of it.": "اختر التصميم العام - ويمكنك تخصيص النصوص والصور والألوان من المحرر أدناه.",
  "Choose the perfect layout for your restaurant menu": "اختر التصميم المثالي لقائمة مطعمك",
  "Choose the template that best matches your restaurant's style. The selected template will be used for all customer-facing menu pages accessed via QR codes.": "اختر القالب الأنسب لأسلوب مطعمك. سيُستخدم القالب المختار في جميع صفحات القائمة التي يصل إليها العملاء عبر رموز QR.",
  "Choose your business type and name. It takes about two minutes.": "اختر نوع نشاطك واسمه. يستغرق الأمر دقيقتين تقريبًا.",
  "Choose your monthly plan": "اختر خطتك الشهرية",
  "Clear Filters": "مسح الفلاتر",
  "Clear cart": "إفراغ السلة",
  "Clear filters": "مسح الفلاتر",
  "Click": "انقر",
  "Click \"Add Variant\" to add size options, flavors, etc.": "انقر على \"إضافة خيار\" لإضافة أحجام أو نكهات وغيرها.",
  "Click \"Use Selected Image\" to apply": "انقر على \"استخدام الصورة المحددة\" للتطبيق",
  "Click restore to revert your database to a previous state.": "انقر على استعادة لإرجاع قاعدة البيانات إلى حالة سابقة.",
  "Click the X to remove": "انقر على X للحذف",
  "Click to edit, double-click for quick edit": "انقر للتعديل، وانقر مرتين للتعديل السريع",
  "Click to toggle payment status": "انقر لتغيير حالة الدفع",
  "Click to upload": "انقر للرفع",
  "Click to upload image": "انقر لرفع صورة",
  "Clinics, salons, hotels and offices - customers book a free slot themselves.": "العيادات والصالونات والفنادق والمكاتب - يحجز العملاء الموعد المتاح بأنفسهم.",
  "Clinics, salons, or any service you book by the slot": "العيادات والصالونات أو أي خدمة تُحجز بالموعد",
  "Close": "إغلاق",
  "Close cart": "إغلاق السلة",
  "Close import": "إغلاق الاستيراد",
  "Close menu": "إغلاق القائمة",
  "Close sidebar": "إغلاق الشريط الجانبي",
  "Closed": "مغلق",
  "Closed this day{v0}. Try another date.": "مغلق في هذا اليوم{v0}. جرّب تاريخًا آخر.",
  "Cloud Mode": "الوضع السحابي",
  "Cloud Mode:": "الوضع السحابي:",
  "Collection": "التشكيلة",
  "Collections": "التشكيلات",
  "Colors": "الألوان",
  "Column deleted": "تم حذف العمود",
  "Coming Soon": "قريبًا",
  "Complete": "إكمال",
  "Complete Order": "إكمال الطلب",
  "Complete POS System": "نظام نقاط بيع متكامل",
  "Completed": "مكتمل",
  "Configure and manage your database connection": "إعداد وإدارة اتصال قاعدة البيانات",
  "Configure thermal printer settings": "إعدادات الطابعة الحرارية",
  "Configure your business": "إعداد نشاطك",
  "Confirm": "تأكيد",
  "Confirm Payment": "تأكيد الدفع",
  "Confirm payment for order {orderCode}?": "تأكيد الدفع للطلب {orderCode}؟",
  "Confirmed": "مؤكد",
  "Connect WhatsApp": "ربط واتساب",
  "Connect WhatsApp first": "اربط واتساب أولًا",
  "Connect your WhatsApp and message customers who agreed to hear from you.": "اربط واتساب وراسل العملاء الذين وافقوا على تلقي رسائلك.",
  "Connect your business's WhatsApp and send a promotion to customers who opted in. Uses your real WhatsApp number, not the official Business API - keep messages occasional to avoid getting flagged.": "اربط واتساب الخاص بنشاطك وأرسل العروض للعملاء الذين وافقوا. يستخدم رقمك الفعلي وليس واجهة Business API الرسمية - اجعل الرسائل متباعدة لتجنب الحظر.",
  "Connect your business's WhatsApp to send marketing messages to opted-in customers.": "اربط واتساب نشاطك لإرسال رسائل تسويقية للعملاء الموافقين.",
  "Connected": "متصل",
  "Connecting…": "جارٍ الاتصال…",
  "Considered pieces, chosen slowly.": "قطع مختارة بعناية وتمهّل.",
  "Consumption Count": "عدد مرات الاستهلاك",
  "Contact": "التواصل",
  "Contact & Compensation": "التواصل والأجر",
  "Contact Information": "معلومات التواصل",
  "Contact email (optional)": "بريد التواصل (اختياري)",
  "Contact restaurant": "تواصل مع المطعم",
  "Continue": "متابعة",
  "Continue browsing": "متابعة التصفح",
  "Continue shopping": "متابعة التسوق",
  "Continue to payment": "المتابعة إلى الدفع",
  "Continue without reward": "المتابعة بدون مكافأة",
  "Copied": "تم النسخ",
  "Copy": "نسخ",
  "Copy Link": "نسخ الرابط",
  "Copy {label}": "نسخ {label}",
  "Cost:": "التكلفة:",
  "Could not create campaign": "تعذر إنشاء الحملة",
  "Could not create member": "تعذر إنشاء العضو",
  "Could not create reward": "تعذر إنشاء المكافأة",
  "Could not create your account": "تعذر إنشاء حسابك",
  "Could not load availability. Try again.": "تعذر تحميل الأوقات المتاحة. حاول مرة أخرى.",
  "Could not load billing": "تعذر تحميل الفوترة",
  "Could not load payment settings": "تعذر تحميل إعدادات الدفع",
  "Could not load reservations": "تعذر تحميل الحجوزات",
  "Could not load times": "تعذر تحميل الأوقات",
  "Could not load your saved design. Please try again.": "تعذر تحميل التصميم المحفوظ. حاول مرة أخرى.",
  "Could not open the payment page": "تعذر فتح صفحة الدفع",
  "Could not reach Stripe": "تعذر الاتصال بـ Stripe",
  "Could not reach Stripe right now": "تعذر الاتصال بـ Stripe حاليًا",
  "Could not read this file.": "تعذرت قراءة هذا الملف.",
  "Could not reserve this time": "تعذر حجز هذا الوقت",
  "Could not save payment methods": "تعذر حفظ طرق الدفع",
  "Could not save settings": "تعذر حفظ الإعدادات",
  "Could not save your changes": "تعذر حفظ تغييراتك",
  "Could not start WhatsApp connection": "تعذر بدء الاتصال بواتساب",
  "Could not start checkout": "تعذر بدء الدفع",
  "Could not update reservation": "تعذر تحديث الحجز",
  "Could not update the payment": "تعذر تحديث الدفع",
  "Could not update theme": "تعذر تحديث الثيم",
  "Could not upload that image": "تعذر رفع هذه الصورة",
  "Count": "العدد",
  "Create": "إنشاء",
  "Create Admin Employee for this Restaurant": "إنشاء موظف مدير لهذا المطعم",
  "Create Backup": "إنشاء نسخة احتياطية",
  "Create Category": "إنشاء تصنيف",
  "Create First Category": "إنشاء أول تصنيف",
  "Create First Item": "إنشاء أول عنصر",
  "Create First Recipe": "إنشاء أول وصفة",
  "Create Item": "إنشاء عنصر",
  "Create New Restaurant": "إنشاء مطعم جديد",
  "Create Restaurant": "إنشاء المطعم",
  "Create Table": "إنشاء طاولة",
  "Create account": "إنشاء حساب",
  "Create an account": "إنشاء حساب",
  "Create and manage database backups": "إنشاء وإدارة النسخ الاحتياطية لقاعدة البيانات",
  "Create member": "إنشاء عضو",
  "Create my account": "إنشاء حسابي",
  "Create my store": "إنشاء متجري",
  "Create plan": "إنشاء خطة",
  "Create the first admin user who will manage this restaurant": "أنشئ أول مستخدم مدير سيتولى إدارة هذا المطعم",
  "Create your account": "أنشئ حسابك",
  "Create your business": "أنشئ نشاطك",
  "Create your business today and start with a free trial. Choose a monthly plan when you go live.": "أنشئ نشاطك اليوم وابدأ بفترة تجريبية مجانية. اختر خطة شهرية عند الإطلاق.",
  "Create your first backup to get started": "أنشئ أول نسخة احتياطية للبدء",
  "Create your {storeName} account in a few seconds.": "أنشئ حسابك في {storeName} خلال ثوانٍ.",
  "Created:": "تاريخ الإنشاء:",
  "Creates database, tables, and admin user automatically": "ينشئ قاعدة البيانات والجداول والمستخدم المدير تلقائيًا",
  "Creating...": "جارٍ الإنشاء...",
  "Currency": "العملة",
  "Currency units per point": "وحدات العملة لكل نقطة",
  "Current Quantity": "الكمية الحالية",
  "Current Stock": "المخزون الحالي",
  "Current image:": "الصورة الحالية:",
  "Current period ends": "تنتهي الفترة الحالية",
  "Current plan": "الخطة الحالية",
  "Current stock:": "المخزون الحالي:",
  "Custom price": "سعر مخصص",
  "Customer": "العميل",
  "Customer Name": "اسم العميل",
  "Customer Name (Optional)": "اسم العميل (اختياري)",
  "Customer accounts & loyalty": "حسابات العملاء والولاء",
  "Customer bill printed successfully": "تمت طباعة فاتورة العميل بنجاح",
  "Customer payments": "مدفوعات العملاء",
  "Customer's transfer receipt": "إيصال تحويل العميل",
  "Customer:": "العميل:",
  "Customers": "العملاء",
  "Customers & Loyalty": "العملاء والولاء",
  "Customers also see \"Only N left\" at this level.": "يرى العملاء أيضًا \"بقي N فقط\" عند هذا المستوى.",
  "Customers can scan this QR code to view the menu": "يمكن للعملاء مسح رمز QR هذا لعرض القائمة",
  "Customers create an account, track orders and earn points on every visit.": "ينشئ العملاء حسابًا ويتتبعون طلباتهم ويكسبون نقاطًا في كل زيارة.",
  "Customers pay in person - at the counter, at pickup or on delivery.": "يدفع العملاء حضوريًا - عند الكاشير أو عند الاستلام أو التوصيل.",
  "Customers pay online by card on a secure Stripe page. Money goes straight to your Stripe account.": "يدفع العملاء بالبطاقة عبر صفحة Stripe آمنة، وتصل الأموال مباشرة إلى حسابك في Stripe.",
  "Customers see your bank details, make the transfer, then upload a photo of the receipt. You approve it on the Orders page.": "يرى العملاء بياناتك البنكية، ويقومون بالتحويل، ثم يرفعون صورة الإيصال. وتوافق عليه من صفحة الطلبات.",
  "Customers swipe through these after the main photo on the product page.": "يتصفح العملاء هذه الصور بعد الصورة الرئيسية في صفحة المنتج.",
  "Customize text displayed to customers": "خصّص النصوص المعروضة للعملاء",
  "Customize the application layout": "خصّص تخطيط التطبيق",
  "Customize your application's color scheme": "خصّص ألوان التطبيق",
  "Customize your business's appearance": "خصّص مظهر نشاطك",
  "DINE_IN": "داخل المطعم",
  "Daily Sales": "المبيعات اليومية",
  "Daily sales loaded successfully": "تم تحميل المبيعات اليومية بنجاح",
  "Dark stage, scrolling marquee, sidebar filters, dense numbered grid": "خلفية داكنة، شريط متحرك، فلاتر جانبية، شبكة مرقّمة كثيفة",
  "Dark theme • Serif headings • Quiet pricing": "ثيم داكن • عناوين كلاسيكية • أسعار هادئة",
  "Dark wood palette • Bold slab type • Rustic": "ألوان الخشب الداكن • خطوط عريضة • طابع ريفي",
  "Dashboard": "لوحة التحكم",
  "Data reset to original": "تمت إعادة البيانات إلى الأصل",
  "Data updated successfully": "تم تحديث البيانات بنجاح",
  "Database": "قاعدة البيانات",
  "Database Host": "مضيف قاعدة البيانات",
  "Database Management": "إدارة قاعدة البيانات",
  "Database Name": "اسم قاعدة البيانات",
  "Database Password": "كلمة مرور قاعدة البيانات",
  "Database Path (SQLite only)": "مسار قاعدة البيانات (SQLite فقط)",
  "Database Port": "منفذ قاعدة البيانات",
  "Database Settings": "إعدادات قاعدة البيانات",
  "Database Type": "نوع قاعدة البيانات",
  "Database User": "مستخدم قاعدة البيانات",
  "Database connection failed": "فشل الاتصال بقاعدة البيانات",
  "Database connection successful!": "تم الاتصال بقاعدة البيانات بنجاح!",
  "Database connection test failed": "فشل اختبار الاتصال بقاعدة البيانات",
  "Database export failed": "فشل تصدير قاعدة البيانات",
  "Database exported successfully!": "تم تصدير قاعدة البيانات بنجاح!",
  "Database initialization failed": "فشلت تهيئة قاعدة البيانات",
  "Database initialized successfully!": "تمت تهيئة قاعدة البيانات بنجاح!",
  "Date": "التاريخ",
  "Date Range": "الفترة",
  "Date blocked": "تم حظر التاريخ",
  "Date unblocked": "تم إلغاء حظر التاريخ",
  "Date:": "التاريخ:",
  "Deactivate": "إلغاء التفعيل",
  "Decrease quantity": "تقليل الكمية",
  "Default - Clean Grid": "افتراضي - شبكة بسيطة",
  "Default - Luxury Gradient": "افتراضي - تدرج فاخر",
  "Default - Simple List": "افتراضي - قائمة بسيطة",
  "Delete": "حذف",
  "Delete Permanently": "حذف نهائي",
  "Delete Recipe": "حذف الوصفة",
  "Delete column": "حذف العمود",
  "Delete entire recipe": "حذف الوصفة كاملة",
  "Delete row": "حذف الصف",
  "Delete this backup": "حذف هذه النسخة الاحتياطية",
  "Delete this service?": "حذف هذه الخدمة؟",
  "Delete variant": "حذف الخيار",
  "Delivery": "توصيل",
  "Delivery Address (Optional)": "عنوان التوصيل (اختياري)",
  "Departments": "الأقسام",
  "Description": "الوصف",
  "Description (optional)": "الوصف (اختياري)",
  "Desk or meeting-room bookings": "حجز المكاتب أو قاعات الاجتماعات",
  "Developers → API keys": "Developers ← API keys",
  "Dine In": "داخل المطعم",
  "Disabled": "معطّل",
  "Disconnect": "قطع الاتصال",
  "Disconnect WhatsApp? You will need to scan a new QR code to reconnect.": "قطع الاتصال بواتساب؟ ستحتاج إلى مسح رمز QR جديد لإعادة الاتصال.",
  "Disconnected": "غير متصل",
  "Discover": "اكتشف",
  "Do I need a credit card to start?": "هل أحتاج إلى بطاقة ائتمان للبدء؟",
  "Double-click": "انقر مرتين",
  "Download Excel": "تنزيل Excel",
  "Download a backup of your entire database": "تنزيل نسخة احتياطية من قاعدة البيانات بالكامل",
  "Download example CSV": "تنزيل ملف CSV نموذجي",
  "Drink categories": "تصنيفات المشروبات",
  "Duration": "المدة",
  "Duration (min)": "المدة (دقيقة)",
  "EST. FIRE · SALT · TIME": "منذ البداية · نار · ملح · وقت",
  "Each category a sliding counter of tall numbered cards": "كل تصنيف شريط منزلق من بطاقات طويلة مرقّمة",
  "Eat Well Menu": "قائمة الأكل الصحي",
  "Ecommerce": "متجر إلكتروني",
  "Edit": "تعديل",
  "Edit Category": "تعديل التصنيف",
  "Edit Employee": "تعديل الموظف",
  "Edit Recipe": "تعديل الوصفة",
  "Edit Restaurant": "تعديل المطعم",
  "Edit Service": "تعديل الخدمة",
  "Edit Stock Item": "تعديل عنصر المخزون",
  "Edit Table": "تعديل الطاولة",
  "Edit a product and turn on \"Track stock for this item\".": "عدّل منتجًا وفعّل \"تتبع المخزون لهذا العنصر\".",
  "Edit recipe": "تعديل الوصفة",
  "Edit variant": "تعديل الخيار",
  "Edit your homepage": "عدّل صفحتك الرئيسية",
  "Edit your storefront's text and images below, then save - changes go live immediately.": "عدّل نصوص وصور واجهة متجرك أدناه ثم احفظ - تظهر التغييرات فورًا.",
  "Edit {itemLabel}": "تعديل {itemLabel}",
  "Editing Instructions:": "تعليمات التعديل:",
  "Editing recipe - Menu item cannot be changed": "تعديل الوصفة - لا يمكن تغيير عنصر القائمة",
  "Elegant - Printed Menu": "أنيق - قائمة مطبوعة",
  "Email": "البريد الإلكتروني",
  "Email (optional - for your confirmation)": "البريد الإلكتروني (اختياري - لتلقي التأكيد)",
  "Email (optional)": "البريد الإلكتروني (اختياري)",
  "Email Address": "البريد الإلكتروني",
  "Email confirmations": "تأكيدات عبر البريد الإلكتروني",
  "Email me about low stock": "راسلني عند انخفاض المخزون",
  "Employee": "موظف",
  "Employee List": "قائمة الموظفين",
  "Employee Management": "إدارة الموظفين",
  "Employee can access the system": "يمكن للموظف الدخول إلى النظام",
  "Employee cannot access the system": "لا يمكن للموظف الدخول إلى النظام",
  "Employee created successfully": "تم إنشاء الموظف بنجاح",
  "Employee deleted successfully": "تم حذف الموظف بنجاح",
  "Employee updated successfully": "تم تحديث الموظف بنجاح",
  "Employee {action}d successfully": "تم {action} الموظف بنجاح",
  "Employees": "الموظفون",
  "Enable Printer": "تفعيل الطابعة",
  "English": "الإنجليزية",
  "English + العربية (customers choose)": "الإنجليزية + العربية (يختار العملاء)",
  "Enter": "Enter",
  "Enter SKU (optional)": "أدخل رمز SKU (اختياري)",
  "Enter a non-zero number of points": "أدخل عدد نقاط غير صفري",
  "Enter a search term and click Search": "أدخل كلمة البحث وانقر على بحث",
  "Enter a valid amount": "أدخل مبلغًا صحيحًا",
  "Enter application name": "أدخل اسم التطبيق",
  "Enter category name": "أدخل اسم التصنيف",
  "Enter customer name": "أدخل اسم العميل",
  "Enter delivery address": "أدخل عنوان التوصيل",
  "Enter image URL or search for images using Google": "أدخل رابط الصورة أو ابحث عن صور عبر Google",
  "Enter item description": "أدخل وصف العنصر",
  "Enter item name": "أدخل اسم العنصر",
  "Enter order code (e.g., BR1-20251024-0001)": "أدخل رمز الطلب (مثال: BR1-20251024-0001)",
  "Enter order code or PIN (e.g., CAS-20251028-0002 or 69709299)": "أدخل رمز الطلب أو PIN (مثال: CAS-20251028-0002 أو 69709299)",
  "Enter order code or PIN manually, or use a QR scanner device/app to scan the payment QR code": "أدخل رمز الطلب أو PIN يدويًا، أو استخدم جهاز/تطبيق ماسح QR لمسح رمز الدفع",
  "Enter phone number": "أدخل رقم الهاتف",
  "Enter the 8-digit PIN from your confirmation": "أدخل رمز PIN المكون من 8 أرقام من رسالة التأكيد",
  "Enter the 8-digit PIN from your order confirmation.": "أدخل رمز PIN المكون من 8 أرقام من تأكيد طلبك.",
  "Enter the URL of your favicon": "أدخل رابط أيقونة الموقع",
  "Enter the URL of your logo": "أدخل رابط الشعار",
  "Enter the customer's phone number to check points, or skip.": "أدخل رقم هاتف العميل للتحقق من النقاط، أو تخطَّ.",
  "Enter your PIN": "أدخل رمز PIN",
  "Enter your business address": "أدخل عنوان نشاطك",
  "Enter your password": "أدخل كلمة المرور",
  "Enter your username": "أدخل اسم المستخدم",
  "Error Color": "لون الخطأ",
  "Every sale updates stock. Sold-out items are marked on your site and you get low stock emails.": "كل عملية بيع تحدّث المخزون. تُعلَّم المنتجات النافدة على موقعك وتصلك رسائل عند انخفاض المخزون.",
  "Everything you need, included": "كل ما تحتاجه، مشمول",
  "Example theme.json": "مثال theme.json"
}
